@if (settings?.length) {
  <div class="items-container mb-2">
    @for (item of settings; track $index) {
      <crm-direction-balance-sheet-settings-form
        class="mb-2"
        [accountId]="accountId"
        [settings]="item"
        (onDeleteClick)="removeSetting($index)"></crm-direction-balance-sheet-settings-form>
    }
  </div>
} @else {
  <div class="w-full flex justify-content-center align-items-center">
    <span class="font-light">Субконто и значения не выбраны</span>
  </div>
}

<div class="w-full flex justify-content-end align-items-center">
  <crm-button
    icon="pi pi-plus"
    label="Добавить"
    styleClass="p-button-text"
    (onClick)="addSetting()"></crm-button>
</div>
